'use client';

export { useTranslation } from '../components/providers/TranslationProvider';
